import React from 'react'
import { appUrls } from '../../../../utils/urls/appUrls'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

export default function SuccessModal({message}) {
    const {
        token,
    } = useSelector((state) => state.authData)
  return (
        <div className='formContainer'>
            <div style={{columnGap: '0.8rem'}} className='greeting d-flex justify-content-center align-items-center'>
                <i style={{fontSize: '1.5rem'}} className={`text-success mdi mdi-checkbox-marked-circle`}></i>
              <p style={{fontSize: '1.3rem'}} className={`text-success text-capitalize`}>
                Upload Successful
              </p>
            </div>
            <form className='mainForm'>
              <div className="row w-100 m-0">
                <div className='text-center mb-5' style={{color: '#31343D'}}>
            <p style={{lineHeight: '1.8rem'}}>{message}</p>
        </div>
      <div className="col-md-12">
        {token && token != '' ?

        <button type="button" className="btn btn-outline-primary mb-4">
            <i className=" mdi mdi-arrow-left-thick mr-1"></i>
            <Link className='text-hover-white' to={appUrls.bank_certificates}>View Certificates</Link>
        </button> :
        <button type="button" className="btn btn-outline-primary mb-4">
            <i className=" mdi mdi-arrow-left-thick mr-1"></i>
            <Link className='text-hover-white' to={appUrls.login}>Login</Link>
        </button>
        }
        {/* <Spinner/> */}
      </div>
              </div>
            </form>
        </div>        
  )
}
